import { forwardRef, type ComponentProps } from 'react';
import { cn } from '@/lib/utils';

// forwardRef, а не ref-проп: в React 18 ссылку через обычные пропы
// компоненту не передать.
export const Input = forwardRef<HTMLInputElement, ComponentProps<'input'>>(
  function Input({ className, type, ...props }, ref) {
    return (
      <input
        ref={ref}
        type={type}
        data-slot="input"
        className={cn(
          'flex h-12 w-full min-w-0 rounded-(--radius-sm) border border-(--border-strong) bg-(--ink) px-4 py-2',
          'text-[15px] text-foreground placeholder:text-(--text-faint)',
          'transition-[border-color,box-shadow] duration-150 ease-(--ease-out)',
          'outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/30',
          'aria-invalid:border-destructive aria-invalid:ring-destructive/25',
          'disabled:cursor-not-allowed disabled:opacity-50',
          'pointer-hover:border-primary/60',
          className,
        )}
        {...props}
      />
    );
  },
);
